export default "__VITE_ASSET__CpXIoj$9__"